import React, { useState, useEffect } from "react";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import axios from "axios";

const PdfViewer = (props) => {
  //========================================================================
  // Zustandsvariablen definieren
  const [pdfSrc, setPdfSrc] = useState(null);
  const [error, setError] = useState(false);

  //========================================================================
  // Logik
  useEffect(() => {
    let isCancelled = false;
    let objectUrl = null;

    const fetchPdf = async () => {
      try {
        // IP-Adresse des Servers
        const url =
          window.location.port === "3000"
            ? `http://${window.location.hostname}:${globalVars.httpPort}/project/documents/${props.element.pdfSrc}`
            : `/project/documents/${props.element.pdfSrc}`;

        const response = await axios.get(url, {
          responseType: "blob",
        });

        if (!isCancelled) {
          objectUrl = URL.createObjectURL(response.data);
          setPdfSrc(objectUrl);
        } else {
          URL.revokeObjectURL(URL.createObjectURL(response.data));
        }
      } catch (error) {
        if (!isCancelled) {
          setError(true);
        }
      }
    };

    fetchPdf();

    return () => {
      isCancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [props.element.pdfSrc]);

  //========================================================================
  // Grafische Darstellung
  if (error) {
    return (
      <p>{language.displayText(["PDF konnte nicht geladen werden", "", ""])}</p>
    );
  }

  return (
    <iframe
      style={{
        ...props.style,
        visibility: props.props.visibility,
      }}
      src={pdfSrc}
    />
  );
};

export default PdfViewer;
